import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { filter, switchMap } from 'rxjs';

import { jsonDefaultRequestOptions } from 'src/app/shared/constants/http.constants';
import { handleHttpResponse } from 'src/app/shared/functions/http.functions';
import { baseEventsUrl } from 'src/app/shared/services/events/events.service';
import {
  ExportEventRequestsPayload,
  GetEventRequests,
  PaginatedEventRequestsResponse
} from 'src/app/shared/services/events/requests/event-requests.models';
import { ExportResponse } from 'src/app/shared/services/utils/shared-utils.models';
import { AuthenticationStore } from 'src/app/shared/state/authentication/authentication.state';

const getEventRequestsUrl = (eventId: string) =>
  `${baseEventsUrl}/${eventId}/requests`;
const exportEventRequestsUrl = (eventId: string) =>
  `${baseEventsUrl}/${eventId}/exportRequestsList`;

@Injectable({
  providedIn: 'root'
})
export class EventRequestsService {
  private _auth0Service = inject(AuthService);
  private _httpClient = inject(HttpClient);
  private _authStore = inject(AuthenticationStore);

  getEventRequests$(
    eventId: string,
    size: number,
    page: number,
    payload: GetEventRequests
  ) {
    return this._auth0Service.isAuthenticated$.pipe(
      filter((authenticated) => authenticated),
      switchMap(() =>
        handleHttpResponse(
          this._httpClient.post<PaginatedEventRequestsResponse>(
            getEventRequestsUrl(eventId),
            payload,
            {
              ...jsonDefaultRequestOptions,
              params: { size, page }
            }
          ),
          'getEventRequests$',
          this._authStore.logout
        )
      )
    );
  }

  exportRequests$(eventId: string, payload: ExportEventRequestsPayload) {
    return this._auth0Service.isAuthenticated$.pipe(
      filter((authenticated) => authenticated),
      switchMap(() =>
        handleHttpResponse(
          this._httpClient.post<ExportResponse>(
            exportEventRequestsUrl(eventId),
            payload,
            jsonDefaultRequestOptions
          ),
          'exportRequests$',
          this._authStore.logout
        )
      )
    );
  }
}
